/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: '[fileUploadCustomSlot]',
})
export class FileUploadCustomSlotDirective {
	constructor(public templateRef: TemplateRef<unknown>) {}
}
